import * as Sentry from '@sentry/vue';
import firebase from 'firebase/app';
import 'firebase/auth';

export default class PurchasedRailcards {
    static getPurchasedRailcardsFromCacheOrRemote(): Promise<Array<PurchasedRailcardSummary>> {
        const metaElement = document.querySelector('meta[name="rcsHostname"]');
        const rcsHostname = metaElement ? metaElement.getAttribute('content') : 'railcards.trainsplit.com';
        const url = new URL(`https://${rcsHostname}/api/account/retail-frontends/railcards-summary`);

        const { currentUser } = firebase.auth();
        // if we don't have a user or we're anonymous, return an empty list
        if (!currentUser || currentUser.isAnonymous) {
            return Promise.resolve([]);
        }

        // if we have a user, check localStorage for a cached version
        const cachedPurchasedRailcards = localStorage.getItem(`purchasedRailcards-${currentUser.uid}`);
        if (cachedPurchasedRailcards) {
            const cachedPurchasedRailcardsSummary: CachedPurchasedRailcardSummary = JSON.parse(cachedPurchasedRailcards);
            // if the cached version is less than 10 minutes old, return it
            if (cachedPurchasedRailcardsSummary.requestTime > Date.now() - 600000) {
                return Promise.resolve(cachedPurchasedRailcardsSummary.data);
            }
        }

        return currentUser.getIdToken()
            .then((firebaseToken) => fetch(url, {
                method: 'GET',
                headers: {
                    'Firebase-Token': firebaseToken,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    // persist in localStorage against the user's uid
                    // make a CachedPurchasedRailcardSummary
                    const cachedPurchasedRailcardSummary: CachedPurchasedRailcardSummary = {
                        requestTime: Date.now(),
                        data,
                    };
                    localStorage.setItem(`purchasedRailcards-${currentUser.uid}`, JSON.stringify(cachedPurchasedRailcardSummary));
                    return data;
                })
                .catch((error) => {
                    Sentry.captureException(error);
                }));
    }
}

export interface PurchasedRailcardSummary {
    railcardId: string;
    type: string;
    dateFrom: string;
    dateTo: string;
    status: string;
    railcardNumber: string;
}

export interface CachedPurchasedRailcardSummary {
    requestTime: number;
    data: Array<PurchasedRailcardSummary>;
}
